/* Purepicked proof components (22 Sep 2026, PP1.6):
   1. Glossary popups for claim chips ([data-pp-term]).
      Desktop/tablet: small card anchored under the chip. Mobile (<750px): card near the
      bottom of the screen over a light backdrop. Closes on ×, outside tap/click or Esc.
   2. Caution card "Show all N reasons" toggle ([data-pp-flags-toggle]).
   3. Lab viewer ([data-pp-lab]): opened by [data-pp-lab-open]; bottom sheet on mobile,
      modal on desktop; tabs; Esc/backdrop/× close; focus returns to the opener.
   One shared popup and the viewer are moved to <body> so no ancestor's overflow,
   transform or stacking context can clip them. */
(function () {
  if (window.__ppProofInit) return;
  window.__ppProofInit = true;

  var MOBILE = window.matchMedia('(max-width: 749px)');

  /* ── 1. Term popups ─────────────────────────────────────── */
  var pop, backdrop, popTitle, popDef, popArrow, popOpener = null;

  function buildPop() {
    if (pop) return;
    backdrop = document.createElement('div');
    backdrop.className = 'pp-term-backdrop';
    backdrop.hidden = true;
    backdrop.addEventListener('click', closePop);

    pop = document.createElement('div');
    pop.className = 'pp-term-pop';
    pop.id = 'PPTermPop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'false');
    pop.setAttribute('aria-labelledby', 'PPTermPopTitle');
    pop.hidden = true;
    pop.innerHTML =
      '<span class="pp-term-pop__arrow" aria-hidden="true"></span>' +
      '<div class="pp-term-pop__head">' +
      '<p class="pp-term-pop__title" id="PPTermPopTitle"></p>' +
      '<button type="button" class="pp-term-pop__close" aria-label="Close">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button></div>' +
      '<p class="pp-term-pop__def"></p>';
    popTitle = pop.querySelector('.pp-term-pop__title');
    popDef = pop.querySelector('.pp-term-pop__def');
    popArrow = pop.querySelector('.pp-term-pop__arrow');
    pop.querySelector('.pp-term-pop__close').addEventListener('click', function () {
      closePop(true);
    });
    document.body.appendChild(backdrop);
    document.body.appendChild(pop);
  }

  function placePop(chip) {
    if (MOBILE.matches) {
      pop.style.left = '';
      pop.style.top = '';
      return;
    }
    var r = chip.getBoundingClientRect();
    var sx = window.pageXOffset || document.documentElement.scrollLeft;
    var sy = window.pageYOffset || document.documentElement.scrollTop;
    var vw = document.documentElement.clientWidth;
    var w = pop.offsetWidth;
    var left = r.left;
    if (left + w > vw - 16) left = Math.max(16, r.right - w);
    pop.style.left = left + sx + 'px';
    pop.style.top = r.bottom + sy + 10 + 'px';
    var arrowX = Math.min(Math.max(r.left + Math.min(22, r.width / 2) - left, 14), w - 26);
    pop.style.setProperty('--pp-arrow-x', arrowX + 'px');
  }

  function openPop(chip) {
    buildPop();
    if (popOpener && popOpener !== chip) popOpener.setAttribute('aria-expanded', 'false');
    popOpener = chip;
    popTitle.textContent = chip.getAttribute('data-pp-term-title') || chip.textContent.trim();
    popDef.textContent = chip.getAttribute('data-pp-term-def') || '';
    chip.setAttribute('aria-expanded', 'true');
    chip.setAttribute('aria-controls', 'PPTermPop');
    pop.hidden = false;
    backdrop.hidden = !MOBILE.matches;
    placePop(chip);
    pop.querySelector('.pp-term-pop__close').focus({ preventScroll: true });
  }

  function closePop(returnFocus) {
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    backdrop.hidden = true;
    if (popOpener) {
      popOpener.setAttribute('aria-expanded', 'false');
      if (returnFocus === true) popOpener.focus({ preventScroll: true });
    }
    popOpener = null;
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-pp-term]');
    if (chip) {
      e.preventDefault();
      if (popOpener === chip && pop && !pop.hidden) closePop(true);
      else openPop(chip);
      return;
    }
    if (pop && !pop.hidden && !pop.contains(e.target)) closePop();
  });

  window.addEventListener('resize', function () {
    if (pop && !pop.hidden && popOpener) {
      backdrop.hidden = !MOBILE.matches;
      placePop(popOpener);
    }
  });

  /* ── 2. Caution reasons toggle ──────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-flags-toggle]');
    if (!btn) return;
    var block = btn.parentElement;
    var extras = block.querySelectorAll('.pp-proof__extra');
    var open = btn.getAttribute('aria-expanded') === 'true';
    extras.forEach(function (li) { li.hidden = open; });
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    btn.textContent = open ? btn.getAttribute('data-more') : btn.getAttribute('data-less');
  });

  /* ── 3. Lab viewer ──────────────────────────────────────── */
  var lab = null, labOpener = null;

  function getLab() {
    if (lab && document.body.contains(lab)) return lab;
    lab = document.querySelector('[data-pp-lab]');
    if (lab && lab.parentElement !== document.body) document.body.appendChild(lab);
    return lab;
  }

  function selectTab(tab, focus) {
    var tabs = lab.querySelectorAll('[data-pp-lab-tab]');
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('is-active', on);
    });
    if (focus) tab.focus();
    var body = lab.querySelector('.pp-lab__body');
    if (body) body.scrollTop = 0;
  }

  function openLab(opener) {
    if (!getLab()) return;
    closePop();
    labOpener = opener || document.activeElement;
    lab.hidden = false;
    document.documentElement.classList.add('pp-lab-open');
    var panel = lab.querySelector('.pp-lab__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function closeLab() {
    if (!lab || lab.hidden) return;
    lab.hidden = true;
    document.documentElement.classList.remove('pp-lab-open');
    if (labOpener && labOpener.focus) labOpener.focus({ preventScroll: true });
    labOpener = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pp-lab-open]');
    if (opener) {
      e.preventDefault();
      openLab(opener);
      return;
    }
    if (lab && !lab.hidden) {
      if (e.target.closest('[data-pp-lab-close]')) {
        closeLab();
        return;
      }
      var tab = e.target.closest('[data-pp-lab-tab]');
      if (tab) selectTab(tab, false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (lab && !lab.hidden) { closeLab(); return; }
      if (pop && !pop.hidden) { closePop(true); return; }
    }
    if (lab && !lab.hidden) {
      var tab = e.target.closest && e.target.closest('[data-pp-lab-tab]');
      if (tab && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        var tabs = Array.prototype.slice.call(lab.querySelectorAll('[data-pp-lab-tab]'));
        var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
        selectTab(tabs[(i + tabs.length) % tabs.length], true);
        e.preventDefault();
      }
      if (e.key === 'Tab') {
        var focusables = lab.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]');
        var list = Array.prototype.filter.call(focusables, function (el) { return el.offsetParent !== null; });
        if (!list.length) return;
        var first = list[0], last = list[list.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    }
  });
})();
